<template>
  <topbar
    :titulo="$t('FINANCEIRO.CONSULTA_BOLETOS')"
    :subtitulo="$t('FINANCEIRO.CONSULTA_BOLETOS_DESCRICAO')"
    :breadcrumbs="breadcrumbs"
  />
</template>

<script>
// Utils & Aux:
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';

export default {
  components: { Topbar },
  data() {
    return {
      breadcrumbs: [
        { titulo: this.$t('FINANCEIRO.FINANCEIRO') },
        { titulo: this.$t('FINANCEIRO.CONSULTA_BOLETOS') },
      ],
    };
  },
};
</script>
